exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-area-placement[data-v-0cb4fbe0] {\n  display: 'flex';\n  position: 'relative';\n  height: '100%';\n}\n", ""]);

// exports
